/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";



Vue.use(Router);


const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "page-010",
            component: () =>
                import("@/views/pages/01/page-010")
        },
        {
            path: "/pages/:kapitel/:id",
            name: "pages",
            linkActiveClass: "active",
            props: true,
            component: () =>
                import("@/views/pages/PageWrapper")
        },
    ]
})




export default router